import { getPaddingVars } from '../../utils/helpers';

/**
 * The panel's overlay padding, whichever control wrote it.
 *
 * Padding is core's spacing support now, so the author gets the Dimensions
 * panel and the theme's spacing presets; the value lands in
 * `style.spacing.padding` and is placed by hand, because it pads the caption
 * overlay rather than the panel wrapper the serializer would target.
 *
 * The block's own `panelPadding` attribute stays readable so panels saved
 * before the move keep their padding — and keep producing byte-identical
 * markup, which is what stops the editor from flagging them as invalid.
 *
 * @param {Object} attributes Panel block attributes.
 * @return {Object} Style object; empty when no padding is set.
 */
export const getPanelPaddingVars = ( { style, panelPadding } ) => {
	const vars = getPaddingVars( style?.spacing?.padding, '--panel-padding' );

	return Object.keys( vars ).length
		? vars
		: getPaddingVars( panelPadding, '--panel-padding' );
};
